var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtn)?_c('b-button',{attrs:{"variant":"warning"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmar()}}},[_c('i',{staticClass:"fa fa-exclamation-triangle mr-2"}),_vm._v("Definir como\n    "+_vm._s(_vm.pagamento.prioritario ? 'não ' : '')+"prioritário\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }